export function windowResize(size) {
  return {type: 'windowResize', size}
}

export function windowInitialSize(initialSize) {
  return {type: 'windowInitialSize', initialSize}
}




/** WEBPACK FOOTER **
 ** ./example/actions/index.js
 **/